/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { translate } from '../translate';

export const DeliveryAddressBox = ({ address }) => (
  <View style={styles.box}>
    <Text style={styles.rowHeader}>{translate('deliveryAddress')}</Text>
    <Text style={{}}>{address.name}</Text>
    <Text style={{}}>{address.name2}</Text>
    <Text style={{}}>{address.street}</Text>
    <Text>
      {address.postalcode} {address.city}
    </Text>
    <Text style={{}}>{address.country}</Text>
  </View>
);
